import {
	getM1CampaignDelays,
	getM1Campaigns,
} from "@/pages/m1/schedule/repositories/M1CampaignRepository";
import { CampaignResponse } from "@/pages/mill/schedule/models/CampaignReponse";
import {
	getCampaignDelays,
	getCampaigns,
} from "@/pages/mill/schedule/repositories/CampaignRepository";
import { MILL_1, MillId } from "@/setup/mill-config/mill-config";

export const CAMPAIGN_LOOKBACK_DAYS = 90;
export const MAX_HEATS_PER_MILL = 100;

export type MillHeatRow = CampaignResponse & {
	DelayTimePercent: number | null;
};

export const getLastHeatsByMill = async (
	millId: MillId,
	signal?: AbortSignal,
) => {
	const start = new Date();
	start.setDate(start.getDate() - CAMPAIGN_LOOKBACK_DAYS);

	const isMill1 = millId === MILL_1.id;
	const [campaigns, delays] = await Promise.all([
		(isMill1 ? getM1Campaigns : getCampaigns)({ start }, signal),
		(isMill1 ? getM1CampaignDelays : getCampaignDelays)({ start }, signal),
	]);

	const lastCampaignByHeat = new Map<number, CampaignResponse>();
	for (const campaign of campaigns) {
		if (campaign.HeatId === null) continue;
		const current = lastCampaignByHeat.get(campaign.HeatId);
		if (!current || new Date(campaign.Start) > new Date(current.Start)) {
			lastCampaignByHeat.set(campaign.HeatId, campaign);
		}
	}

	const delayByCampaign = new Map(
		delays.map((delay) => [delay.CampaignId, delay.DelayTimePercent]),
	);

	return Array.from(lastCampaignByHeat.values())
		.sort((a, b) => new Date(b.Start).getTime() - new Date(a.Start).getTime())
		.slice(0, MAX_HEATS_PER_MILL)
		.map((campaign) => ({
			...campaign,
			DelayTimePercent: delayByCampaign.get(campaign.CampaignId) ?? null,
		})) as MillHeatRow[];
};
